module.exports = __webpack_public_path__ + "static/media/waterfall.fedb7b4a.png";